import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth-service/auth.service';
import { COMPANY_CONFIGURATION_FACADE } from 'src/app/core/services/facades';
import { BasicDataResult } from 'src/app/core/services/data-orchestrator';
import { CompanyConfigurationDto } from 'src/app/shared/models';
import { DashboardRouteSegments } from 'src/app/shared/constants';

export const inspirationGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const companyConfigurationFacade = inject(COMPANY_CONFIGURATION_FACADE);
  const router = inject(Router);

  const loggedInUser = authService.getLoggedInUser();

  const { data$ } = companyConfigurationFacade.getCompanyConfiguration({
    companyId: loggedInUser.CompanyId,
    readFromCacheFirst: true,
    disableAutoRefresh: false,
    writeToCache: true,
  });

  return data$.pipe(
    filter((result: BasicDataResult<CompanyConfigurationDto>) => !result.loading),
    take(1),
    map((result: BasicDataResult<CompanyConfigurationDto>) => {
      if (result.error || !result.data?.ShowInspirationBlogs) {
        return router.createUrlTree(['/', DashboardRouteSegments.Dashboard]);
      }

      return true;
    }),
  );
};
